export const SCANS = {
  TITLE: 'Scans',
  TABS: {
    APPSEC: 'AppSec',
  },
  APPSEC: {
    TITLE: 'Repositories',
    ADD_REPOSITORY: 'Add repository',
    TABLE: {
      NAME: 'Repository',
      PROJECT_KEY: 'Project key',
      SCM: 'SCM',
      CLONE_URL: 'Clone URL',
      CREATED_AT: 'Created',
      ACTIONS: 'Actions',
      DELETE: 'Delete repository',
    },
    DIALOG: {
      TITLE: 'Add repository',
      NAME: 'Repository name',
      NAME_PLACEHOLDER: 'my-service',
      PROJECT_KEY: 'Project key',
      PROJECT_KEY_PLACEHOLDER: 'Optional',
      SCM: 'SCM',
      SCM_PLACEHOLDER: 'Select SCM',
      CLONE_URL: 'Clone URL (SSH)',
      CLONE_URL_PLACEHOLDER: 'git@host:project/repo.git',
      CANCEL: 'Cancel',
      SUBMIT: 'Add',
    },
    DELETE_DIALOG: {
      TITLE: 'Delete {name}?',
      DESCRIPTION:
        'This permanently deletes the repository and all its SAST, SCA and secrets findings, including muted ones. The repository will no longer be scanned. This cannot be undone.',
      CANCEL: 'Cancel',
      CONFIRM: 'Delete',
    },
    TOAST: {
      CREATED: 'Repository added',
      DELETED: 'Repository removed',
      CREATE_ERROR: 'Error adding repository',
      DELETE_ERROR: 'Error removing repository',
      LOAD_ERROR: 'Error loading repositories',
    },
  },
}
